export const vehicleList = [
    {
        "name": "Personal Speeder",
        "description": "Small and fast single-rider vehicle.",
        "isMechSuit": false,
        "currentlyEntered": false,
        "levelReq": 1,
        "maxPassengers": 0,
        "movement": 40,
        "baseHP": 20,
        "currentHP": 20,
        "baseDIS": 0,
        "currentDIS": 0,
        "baseKIN": 0,
        "currentKIN": 0,
        "maxCapacity": 10,
        "currentCapacity": 0,
        "inventory": [],
        "weaponSlots": 1,
        "weapons": [],
        "modSlots": 2,
        "mods": [],
        "notes": null,
        "STRmod": 0,
        "DEXmod": 0,
        "CONmod": 0
    },
    {
        "name": "Exploration Rover",
        "description": "Slow but sturdy multi-terrain rover.",
        "isMechSuit": false,
        "currentlyEntered": false,
        "levelReq": 1,
        "maxPassengers": 3,
        "movement": 20,
        "baseHP": 48,
        "currentHP": 48,
        "baseDIS": 0,
        "currentDIS": 0,
        "baseKIN": 0,
        "currentKIN": 0,
        "maxCapacity": 60,
        "currentCapacity": 0,
        "inventory": [],
        "weaponSlots": 2,
        "weapons": [],
        "modSlots": 4,
        "mods": [],
        "notes": null,
        "STRmod": 0,
        "DEXmod": 0,
        "CONmod": 0
    },
    {
        "name": "Hauler's Exoskeleton",
        "description": "Simple mechanized exoskeleton that increases the strength of the user.",
        "isMechSuit": true,
        "currentlyEntered": false,
        "levelReq": 30,
        "maxPassengers": 0,
        "movement": 7,
        "baseHP": 28,
        "currentHP": 28,
        "baseDIS": 0,
        "currentDIS": 0,
        "baseKIN": 0,
        "currentKIN": 0,
        "maxCapacity": 10,
        "currentCapacity": 0,
        "inventory": [],
        "weaponSlots": 1,
        "weapons": [],
        "modSlots": 2,
        "mods": [],
        "notes": null,
        "STRmod": 2,
        "DEXmod": 0,
        "CONmod": 0
    },
    {
        "name": "Paladin-Class Combat Mech",
        "description": "Large and sturdy combat mech suit that turns the user into an absolute killing machine.",
        "isMechSuit": true,
        "currentlyEntered": false,
        "levelReq": 50,
        "maxPassengers": 0,
        "movement": 15,
        "baseHP": 48,
        "currentHP": 48,
        "baseDIS": 12,
        "currentDIS": 12,
        "baseKIN": 12,
        "currentKIN": 12,
        "maxCapacity": 10,
        "currentCapacity": 0,
        "inventory": [],
        "weaponSlots": 2,
        "weapons": [],
        "modSlots": 4,
        "mods": [],
        "notes": null,
        "STRmod": 2,
        "DEXmod": 1,
        "CONmod": 2
    }
]